import React from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { injectIntl } from "react-intl";
import confirmDelete from '../ConfirmDelete';
import getEncodedImageUrl from "../../helpers/getEncodedImageUrl";
import ImgToolTip from '../ImgTooltip';

const AssociationRow = ({ id, name, login, password, logo, scheduleItemCud, scheduleItemsFetch, intl }) => {
  const delTheme = (id) => {
    scheduleItemCud('association', "delete", id)
    scheduleItemsFetch();
  };
  const delText = intl.formatMessage({ id: 'confirm.s.association-delete' })

  return (
    <div className="added-event-container">
      <div className="e-name-container">
        <div className="e-name">
          <div className="event-icon-container">
            {logo ? (
              <img className="event-icon rounded-circle" src={getEncodedImageUrl(logo, 85, 85)} alt="" />
            ) : (
                <img
                  className="event-icon rounded-circle"
                  src={`https://ui-avatars.com/api/?name=${name}&size=85&color=ff7142`}
                  alt=""
                />
              )}
          </div>
          <div className="m-l-45 justify-content-center">
            <h6>
              {name}
            </h6>
            <span>{login}</span>
          </div>
        </div>
        <div className="del-event-container justify-content-center">
          <Button
            onClick={() => {
              confirmDelete(intl, id, undefined, delTheme, delText);
            }}
          >
            <ImgToolTip className="icon-normal" intl={intl} placement="left" tooltiptext={`action.delete-association`} id="tooltip-download-latest" img={`/icons/delete.png`} />
            <ImgToolTip className="icon-hover" intl={intl} placement="left" tooltiptext={`action.delete-association`} id="tooltip-download-latest-hover" img={`/icons/delete-hover.png`} />
            <ImgToolTip className="icon-focus" intl={intl} placement="left" tooltiptext={`action.delete-association`} id="tooltip-download-latest-focus" img={`/icons/delete-focus.png`} />
          </Button>
        </div>
      </div>
      <Link className="d-flex w-10" to={`/association/edit/${id}`}>
        <Button className="btn-return">{intl.formatMessage({ id: 'button.s.association-update' })}</Button>
      </Link>
    </div>
  );
};

export default injectIntl(AssociationRow);
